import { render, staticRenderFns } from "./ServerVersion.vue?vue&type=template&id=3ce332fd&scoped=true&"
import script from "./ServerVersion.vue?vue&type=script&lang=js&"
export * from "./ServerVersion.vue?vue&type=script&lang=js&"
import style0 from "./ServerVersion.vue?vue&type=style&index=0&id=3ce332fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce332fd",
  null
  
)

export default component.exports